import React, { Component } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'


/* 
    Props
    
    title: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    
*/
class SFDonutChart extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (
            <HighchartsReact
                highcharts={Highcharts}
                
                options={{
                    chart: {
                        type: 'pie',
                        renderTo: 'container',
                        height: 140,
                        width:'250'
                    },
                    exporting:  {
                        enabled: false,
                    },
                    credits: {
                        enabled: false,
                    },
                    colors: ['#7AC642', '#FF9F46', '#FF0000', '#C6C6C6'],
                    title: {
                        verticalAlign: 'middle',
                        floating: true,
                        useHTML: true,
                        text: "<div class='text-center fontClass-14'>60% <br><small>Completed</small></div>"
                    },
                    plotOptions: {
                        pie: {
                            innerSize: '70%',
                            dataLabels: {
                                enabled: false,
                            }
                        },
                    },
                    series: [{
                        data: [
                            ['Completed', 3],
                            ['In-Progress', 1],
                            ['Missed', 1],
                            ['Upcoming', 1],
                        ]
                    }]
                }}
            >

            </HighchartsReact>
        )
    }
}

export default SFDonutChart;